import { useState } from "react";
import type { FC, ReactNode } from "react";
import { useIntl } from "react-intl";
import { useAccountSwitcherContext } from "../../../MmAccountSwitcher/AccountSwitcherContext";
import { AccountSwitcherLogo } from "../../../MmAccountSwitcher/components/AccountSwitcherLogo/AccountSwitcherLogo";
import { MobileNavigationMenuButton } from "../MobileNavigationMenuButton/MobileNavigationMenuButton";
import { StyledWrapper as StyledHeaderWrapper } from "../MobileNavigationOpen/MobileNavigationHeader/styled";
import { StyledWrapper } from "../MobileNavigationOpen/styled";
import { StyledSection } from "../styled";
import { MobileAccountSwitcherTree } from "./components/MobileAccountSwitcherTree/MobileAccountSwitcherTree";
import "@nectary/components/title";

export const MobileNavigationAccountSwitcher: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [show, setShow] = useState<boolean>(false);
  const { setSearchBarFocus, setSearchValue } = useAccountSwitcherContext();
  const intl = useIntl();

  const toggleShow = () => {
    if (show) {
      setSearchBarFocus(false);
      setSearchValue("");
    }
    setShow((prevState) => !prevState);
  };

  return (
    <>
      <AccountSwitcherLogo clickable onClick={toggleShow} />
      {show && (
        <StyledWrapper>
          <StyledHeaderWrapper>
            <StyledSection />
            <StyledSection align="center" flex={2}>
              <sinch-title
                type="m"
                level="1"
                text={intl.formatMessage({ id: "accountSwitcherTitle" })}
              />
            </StyledSection>
            <StyledSection align="flex-end">
              <MobileNavigationMenuButton onClick={toggleShow}>
                {children}
              </MobileNavigationMenuButton>
            </StyledSection>
          </StyledHeaderWrapper>
          <MobileAccountSwitcherTree />
        </StyledWrapper>
      )}
    </>
  );
};
